import { ThemeEnum } from '../../../Theme';

export enum ButtonBGEnum {
  Dark = 'Dark',
  Light = 'Light',
}

export type ButtonBGType<Theme extends ThemeEnum> = Theme extends ThemeEnum.Site
  ? keyof typeof ButtonBGEnum
  : never;
